import React from 'react';
import {AnchorLink} from '../AnchorLink';

export const SignUpLink: React.FC = ({children}) => (
  <AnchorLink href="https://dashboard.monei.com/?action=signUp">{children}</AnchorLink>
);
